import React, { useState } from 'react'
import { AttributeModalWrapper } from '../data/css/PremiintStyles';

import { GameButton, Modal, ModalContent, ModalOverlay } from './LeftDiv'
import { submitTokenTransaction } from '../data/functions/control_panel';

const WithdrawModal = (props) => {
    const showWithdrawModal = props.showWithdrawModal;
    const setShowWithdrawModal = props.setShowWithdrawModal;
    const token_name = props.token_name;
    const precision = props.precision;
    const contract = props.contract;
    const setEnterModalText = props.setEnterModalText;
    const setLoadingDisplay = props.setLoadingDisplay;
    const setEnterButtonsDisplay = props.setEnterButtonsDisplay;
    const setEnterModalDisplay = props.setEnterModalDisplay;
    const tokenAction = props.tokenAction;

    const [amount, setAmount] = useState("");

  return (
    <AttributeModalWrapper className={!showWithdrawModal && "hidden"}>
        
        {/* <AttributeModalInnerWrapper> */}
            <ModalContent>
            Enter Amount
                <br/>
                <input 
                placeholder='e.g. 69.420'
                value={amount} onChange={(e) => setAmount(e.target.value)} />
            
        </ModalContent>

      {/* </AttributeModalInnerWrapper> */}
      <br/>
      <GameButton onClick={() => {
        setShowWithdrawModal(false);
        submitTokenTransaction(tokenAction, token_name, precision, amount, contract, setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay)
      }
      }>
          {tokenAction} {amount} {token_name}
      </GameButton>
      
      <br/>
      <GameButton onClick={() => setShowWithdrawModal(false) }>
        Close Window
      </GameButton>
      </AttributeModalWrapper>
  )
}

export default WithdrawModal